import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './en'
import cn from './cn'
import jp from './jp'
import ko from './ko'
import tailand from './tailand'
import zh from './zh'
import yn from './yn'
import { getSavedLocale } from './options'

Vue.use(VueI18n);

const messages = {
  en,
  cn,
  jp,
  ko,
  tailand,
  zh,
  yn,
}

const aitokenPageMessages = {
  cn: {
    aitoken: {
      brand: '核元智算',
      connectWallet: '连接钱包',
      connectLogin: '连接钱包 / 授权登录',
      language: '语言',
      common: {
        record: '记录',
        confirm: '确认',
        submit: '确认提交',
        buyNow: '立即抢购',
        subscribeNow: '立即认购',
        purchased: '已购买',
        onceOnly: '限购一次',
        noQuickPlans: '暂无抢购配置',
        noDevicePlans: '暂无认购配置',
        noQuickOrders: '暂无抢购订单',
        noDeviceOrders: '暂无认购订单',
        noData: '暂无数据',
        requestFailed: '请求失败',
        operationFailed: '操作失败',
        operationSuccess: '操作成功',
        loginFirst: '请先授权登录',
      },
      tabs: {
        home: '首页',
        business: '业务',
        orders: '订单',
        referral: '推荐',
      },
      home: {
        title: '全球 AI 模型的数据与信任层',
        intro: 'GMI Cloud Pte.Ltd AI 原生推理云，接入核元智算原有钱包授权、充值提现和认购流程。',
        stat1: '抢购门槛',
        stat2: '最高月化',
        stat3: '推荐奖励',
        enterBusiness: '进入业务台',
        upgradeTitle: '1000 USDT 抢占城市合伙人席位（限时限量）',
        upgradeDesc: '每人仅可购买一次，购买后立即升级为城市合伙人席位。',
        featureTitle: '三大收益模式',
        featureDesc: '算力、设备和推荐收益统一进入核元智算原业务流程。',
        feature1Title: 'GMI Cloud Pte.Ltd',
        feature1Desc: 'NVIDIA 驱动，Serverless 推理和专属 GPU 基础设施。',
        feature2Title: '小额算力快赚',
        feature2Desc: '短周期抢购入口，点击后进入核元智算原有认购流程。',
        feature3Title: '设备算力认购',
        feature3Desc: '设备类业务统一复用原项目的链上授权和订单确认能力。',
        feature4Title: '推荐奖励',
        feature4Desc: '推荐数据和佣金提现继续走核元智算现有账户体系。',
        bindTitle: '绑定上级',
        bindDesc: '请输入邀请地址或邀请码，绑定后即可参与业务和推荐奖励。',
        bindPlaceholder: '请输入邀请码',
        bindButton: '确定绑定',
        buyFailed: '购买失败',
        bindSuccess: '绑定成功',
      },
      business: {
        title: 'Token 算力额度激活、Token 设备购买、推荐奖励',
        desc1: '算力额度激活，收益每日结算，到期返还本金。',
        desc2: '设备算力认购，收益每日结算。',
        walletTitle: '钱包资产',
        walletDesc: '当前可用余额与推广佣金',
        balance: 'USDT 余额',
        commission: '佣金',
        recharge: '钱包充值',
        balanceWithdraw: '余额提现',
        commissionWithdraw: '佣金提现',
        commissionToBalance: '佣金转余额',
        quickTitle: '算力额度激活',
        quickDesc: '每个档位每位用户仅限购买一次',
        shortTerm: '短期参与型',
        day: '天',
        tokenUnit: '个 Token',
        dailyRate: '日化',
        remaining: '剩余',
        quickRule: '抢购成功后每日回收益，周期结束返还本金；未抢中不扣款。',
        quickSuccess: '抢购成功',
        deviceTitle: '算力设备部署',
        deviceDesc: '投入标准为 1260 USDT/台。',
        longTerm: '长期产出型',
        recommend: '推荐',
        cycle: '周期',
        longCycle: '长期',
        unitPrice: '单台价格',
        deviceRule: '设备认购每日结算收益',
        deviceSuccess: '认购成功',
        chooseDeviceMethod: '选择设备获取方式',
        onlineHost: '线上托管',
        onlineHostDesc: '由平台统一托管设备，省心省力',
        delivery: '到家',
        comingSoon: '待开放',
        deliveryDesc: '设备配送到家，需填写收货信息',
        deliveryTitle: '填写收货信息',
        receiverName: '收货姓名',
        receiverPhone: '收货电话',
        receiverAddress: '收货地址',
        receiverNamePlaceholder: '请输入收货人姓名',
        receiverPhonePlaceholder: '请输入收货人电话',
        receiverAddressPlaceholder: '请输入详细收货地址',
        fillName: '请填写收货姓名',
        fillPhone: '请填写收货电话',
        fillAddress: '请填写收货地址',
        devicePower: '设备算力',
      },
      orders: {
        title: '我的订单',
        refresh: '刷新订单',
        quickTitle: '小额抢购订单',
        quickDesc: '未抢中订单不扣款，抢购成功后每日结算收益。',
        deviceTitle: '设备认购订单',
        deviceDesc: '认购成功后每日结算收益',
        countUnit: '条',
        quickPower: '小额算力',
        queuing: '抢购中',
        running: '运行中',
        finished: '已结束',
        configuring: '配置中',
        closed: '未运行',
        invested: '投入',
        cycle: '周期',
        day: '天',
        rate: '收益率',
        dailyIncome: '每日收益',
        type: '类型',
        deviceCode: '设备编码',
        hosting: '托管',
        delivery: '到家',
        ranDays: '已运行',
        earned: '已收益',
      },
      referral: {
        defaultLevel: '算力节点',
        myToken: '我的 Token',
        tokenUnit: '个',
        myDevice: '我的设备',
        deviceUnit: '台',
        inviteLink: '邀请链接',
        myReferrer: '我的推荐人',
        todayIncome: '今日收益',
        reward: '奖励',
        quotaIncome: '额度收益',
        deviceIncome: '设备收益',
        channelIncome: '渠道收益',
        myTeam: '我的团队',
        myReferral: '我的推荐',
        teamDevice: '团队设备',
        directDevice: '直推设备',
        deviceCount: '设备数量',
      },
      homePages: {
        usdtRecord: 'USDT记录',
        commissionRecord: '佣金记录',
        balanceWithdrawalRecord: '余额提现记录',
        commissionWithdrawalRecord: '佣金提现记录',
        time: '时间',
        amount: '数量',
        description: '描述',
        withdrawTime: '提现时间',
        money: '金额',
        received: '到账',
        fee: '手续费',
        status: '状态',
        noRecords: '暂无记录',
        loading: '加载中...',
        noMore: '没有更多了',
        pending: '待处理',
        paid: '已到账',
        rejected: '已拒绝',
        unknown: '未知',
        balanceWithdrawal: '余额提现',
        commissionWithdrawal: '佣金提现',
        record: '记录',
        balance: '余额',
        commission: '佣金',
        availableBalance: '可用余额',
        availableCommission: '可用佣金',
        withdrawAmount: '提现数量',
        withdrawPlaceholder: '请输入提现数量',
        receivedAmount: '到账数量',
        confirmWithdraw: '确认提现',
        insufficientBalance: '余额不足',
        insufficientCommission: '佣金不足',
        signatureFailed: '签名失败',
        commissionToBalance: '佣金转余额',
        exchangeRate: '1:1 兑换',
        transferAmount: '转入数量',
        transferPlaceholder: '请输入转入数量',
        balanceReceived: '到账余额',
        freeFee: '免手续费',
        confirmTransfer: '确认转入余额',
        transferSuccess: '转入成功',
        transferFailed: '转入失败',
      },
    },
  },
  en: {
    aitoken: {
      brand: 'GMI Cloud',
      connectWallet: 'Connect Wallet',
      connectLogin: 'Connect Wallet / Login',
      language: 'Language',
      common: { record: 'Records', confirm: 'Confirm', submit: 'Submit', buyNow: 'Buy Now', subscribeNow: 'Subscribe Now', purchased: 'Purchased', onceOnly: 'One purchase only', noQuickPlans: 'No quick plans', noDevicePlans: 'No device plans', noQuickOrders: 'No quick orders', noDeviceOrders: 'No device orders', noData: 'No data', requestFailed: 'Request failed', operationFailed: 'Operation failed', operationSuccess: 'Operation successful', loginFirst: 'Please authorize login first' },
      tabs: { home: 'Home', business: 'Business', orders: 'Orders', referral: 'Referral' },
      home: { title: 'The data and trust layer for global AI models.', intro: 'GMI Cloud Pte.Ltd AI native inference cloud connects wallet authorization, recharge, withdrawal, and subscription flows.', stat1: 'Entry threshold', stat2: 'Max monthly rate', stat3: 'Referral reward', enterBusiness: 'Enter Business', upgradeTitle: '1000 USDT City Partner Seat, limited time and quantity', upgradeDesc: 'Each user can buy once. Upgrade to city partner seat immediately after purchase.', featureTitle: 'Three income models', featureDesc: 'Hashrate, device, and referral income enter the same account flow.', feature1Title: 'GMI Cloud Pte.Ltd', feature1Desc: 'NVIDIA powered serverless inference and dedicated GPU infrastructure.', feature2Title: 'Quick Hashrate', feature2Desc: 'Short-cycle purchase entry connected to the original subscription flow.', feature3Title: 'Device Hashrate Subscription', feature3Desc: 'Device orders reuse on-chain authorization and order confirmation.', feature4Title: 'Referral Rewards', feature4Desc: 'Referral data and commission withdrawals continue through the account system.', bindTitle: 'Bind Referrer', bindDesc: 'Enter invitation address or code to join business and referral rewards.', bindPlaceholder: 'Enter invitation code', bindButton: 'Bind Now', buyFailed: 'Purchase failed', bindSuccess: 'Bound successfully' },
      business: { title: 'Token hashrate quota activation, device purchase, and referral rewards', desc1: 'Activate hashrate quota. Income settles daily and principal returns at maturity.', desc2: 'Subscribe to device hashrate. Income settles daily.', walletTitle: 'Wallet Assets', walletDesc: 'Available balance and referral commission', balance: 'USDT Balance', commission: 'Commission', recharge: 'Recharge', balanceWithdraw: 'Balance Withdrawal', commissionWithdraw: 'Commission Withdrawal', commissionToBalance: 'Commission to Balance', quickTitle: 'Hashrate Quota Activation', quickDesc: 'Each user can buy each tier only once', shortTerm: 'Short-term', day: 'days', tokenUnit: 'Token', dailyRate: 'Daily', remaining: 'Remaining', quickRule: 'Income returns daily after success, principal returns at maturity. No charge if not won.', quickSuccess: 'Purchase successful', deviceTitle: 'Hashrate Device Deployment', deviceDesc: 'Standard investment is 1260 USDT per device.', longTerm: 'Long-term', recommend: 'Recommended', cycle: 'Cycle', longCycle: 'Long-term', unitPrice: 'Unit Price', deviceRule: 'Device subscriptions settle income daily', deviceSuccess: 'Subscription successful', chooseDeviceMethod: 'Choose device method', onlineHost: 'Online Hosting', onlineHostDesc: 'The platform hosts the device for you.', delivery: 'Home Delivery', comingSoon: 'Coming Soon', deliveryDesc: 'Device delivered to your address. Shipping info required.', deliveryTitle: 'Shipping Information', receiverName: 'Receiver Name', receiverPhone: 'Phone', receiverAddress: 'Address', receiverNamePlaceholder: 'Enter receiver name', receiverPhonePlaceholder: 'Enter phone number', receiverAddressPlaceholder: 'Enter detailed address', fillName: 'Please enter receiver name', fillPhone: 'Please enter phone number', fillAddress: 'Please enter address', devicePower: 'Device Hashrate' },
      orders: { title: 'My Orders', refresh: 'Refresh Orders', quickTitle: 'Quick Purchase Orders', quickDesc: 'No charge if not won. Income settles daily after successful purchase.', deviceTitle: 'Device Subscription Orders', deviceDesc: 'Income settles daily after successful subscription', countUnit: 'items', quickPower: 'Quick Hashrate', queuing: 'Queuing', running: 'Running', finished: 'Finished', configuring: 'Configuring', closed: 'Not running', invested: 'Invested', cycle: 'Cycle', day: 'days', rate: 'Rate', dailyIncome: 'Daily Income', type: 'Type', deviceCode: 'Device Code', hosting: 'Hosting', delivery: 'Delivery', ranDays: 'Running Days', earned: 'Earned' },
      referral: { defaultLevel: 'Hashrate Node', myToken: 'My Token', tokenUnit: '', myDevice: 'My Devices', deviceUnit: '', inviteLink: 'Invitation Link', myReferrer: 'My Referrer', todayIncome: 'Today Income', reward: 'Reward', quotaIncome: 'Quota Income', deviceIncome: 'Device Income', channelIncome: 'Channel Income', myTeam: 'My Team', myReferral: 'My Referrals', teamDevice: 'Team Devices', directDevice: 'Direct Devices', deviceCount: 'Device Count' },
      homePages: {
        usdtRecord: 'USDT Records', commissionRecord: 'Commission Records', balanceWithdrawalRecord: 'Balance Withdrawal Records', commissionWithdrawalRecord: 'Commission Withdrawal Records',
        time: 'Time', amount: 'Amount', description: 'Description', withdrawTime: 'Withdrawal Time', money: 'Amount', received: 'Received', fee: 'Fee', status: 'Status',
        noRecords: 'No records', loading: 'Loading...', noMore: 'No more data', pending: 'Pending', paid: 'Paid', rejected: 'Rejected', unknown: 'Unknown',
        balanceWithdrawal: 'Balance Withdrawal', commissionWithdrawal: 'Commission Withdrawal', record: 'Records', balance: 'Balance', commission: 'Commission',
        availableBalance: 'Available Balance', availableCommission: 'Available Commission', withdrawAmount: 'Withdrawal Amount', withdrawPlaceholder: 'Enter withdrawal amount',
        receivedAmount: 'Received Amount', confirmWithdraw: 'Confirm Withdrawal', insufficientBalance: 'Insufficient balance', insufficientCommission: 'Insufficient commission',
        signatureFailed: 'Signature failed', commissionToBalance: 'Commission to Balance', exchangeRate: '1:1 Exchange', transferAmount: 'Transfer Amount',
        transferPlaceholder: 'Enter transfer amount', balanceReceived: 'Balance Received', freeFee: 'No fee', confirmTransfer: 'Transfer to Balance',
        transferSuccess: 'Transfer successful', transferFailed: 'Transfer failed',
      },
    },
  },
}

aitokenPageMessages.jp = JSON.parse(JSON.stringify(aitokenPageMessages.en));
aitokenPageMessages.jp.aitoken.tabs = { home: 'ホーム', business: '業務', orders: '注文', referral: '紹介' };
aitokenPageMessages.jp.aitoken.connectWallet = 'ウォレット接続';
aitokenPageMessages.jp.aitoken.connectLogin = 'ウォレット接続 / ログイン';
Object.assign(aitokenPageMessages.jp.aitoken.common, {
  record: '記録', confirm: '確認', submit: '送信', buyNow: '今すぐ購入', subscribeNow: '今すぐ申込',
  purchased: '購入済み', onceOnly: '1回限定', noQuickPlans: '購入プランはありません', noDevicePlans: 'デバイスプランはありません',
  noQuickOrders: '購入注文はありません', noDeviceOrders: 'デバイス注文はありません', noData: 'データなし',
  requestFailed: 'リクエスト失敗', operationFailed: '操作失敗', operationSuccess: '操作成功', loginFirst: '先に認証ログインしてください'
});
Object.assign(aitokenPageMessages.jp.aitoken.home, {
  title: 'グローバルAIモデルのデータと信頼レイヤー', intro: 'GMI Cloud Pte.Ltd AIネイティブ推論クラウドは、ウォレット認証、入出金、申込フローに接続します。',
  stat1: '参加条件', stat2: '最高月利', stat3: '紹介報酬', enterBusiness: '業務ページへ',
  upgradeTitle: '1000 USDT 都市パートナー枠（期間・数量限定）', upgradeDesc: '各ユーザー1回のみ購入可能。購入後すぐに都市パートナー枠へ昇格します。',
  featureTitle: '3つの収益モデル', featureDesc: '算力、デバイス、紹介収益を同一アカウント体系で管理します。',
  feature1Desc: 'NVIDIA駆動、Serverless推論と専用GPUインフラ。', feature2Title: '小額算力クイック購入',
  feature2Desc: '短周期の購入入口。既存の申込フローに接続します。', feature3Title: 'デバイス算力申込',
  feature3Desc: 'デバイス注文はチェーン認証と注文確認機能を共用します。', feature4Title: '紹介報酬',
  feature4Desc: '紹介データとコミッション出金は既存アカウント体系で処理します。', bindTitle: '上位を紐付け',
  bindDesc: '招待アドレスまたは招待コードを入力してください。紐付け後、業務と紹介報酬に参加できます。',
  bindPlaceholder: '招待コードを入力', bindButton: '紐付けを確認', buyFailed: '購入失敗', bindSuccess: '紐付け成功'
});
Object.assign(aitokenPageMessages.jp.aitoken.business, {
  title: 'Token算力枠の有効化、Tokenデバイス購入、紹介報酬', desc1: '算力枠を有効化し、収益は毎日精算、満期で元本返還。',
  desc2: 'デバイス算力申込、収益は毎日精算。', walletTitle: 'ウォレット資産', walletDesc: '利用可能残高と紹介コミッション',
  balance: 'USDT残高', commission: 'コミッション', recharge: 'チャージ', balanceWithdraw: '残高出金',
  commissionWithdraw: 'コミッション出金', commissionToBalance: 'コミッションを残高へ', quickTitle: '算力枠有効化',
  quickDesc: '各ランクはユーザーごとに1回のみ購入可能', shortTerm: '短期参加型', day: '日', tokenUnit: 'Token',
  dailyRate: '日利', remaining: '残り', quickRule: '成功後は毎日収益を受け取り、満期で元本返還。未当選は課金されません。',
  deviceTitle: '算力デバイス配置', deviceDesc: '標準投入額は1台あたり1260 USDT。', longTerm: '長期産出型',
  recommend: 'おすすめ', cycle: '周期', longCycle: '長期', unitPrice: '単価', deviceRule: 'デバイス申込は毎日収益を精算します',
  chooseDeviceMethod: 'デバイス取得方法を選択', onlineHost: 'オンライン委託', onlineHostDesc: 'プラットフォームがデバイスを一括管理します',
  delivery: '自宅配送', comingSoon: '準備中', deliveryDesc: 'デバイスを自宅へ配送、受取情報が必要です',
  deliveryTitle: '受取情報を入力', receiverName: '受取人名', receiverPhone: '電話番号', receiverAddress: '住所',
  receiverNamePlaceholder: '受取人名を入力', receiverPhonePlaceholder: '電話番号を入力', receiverAddressPlaceholder: '詳細住所を入力',
  fillName: '受取人名を入力してください', fillPhone: '電話番号を入力してください', fillAddress: '住所を入力してください', devicePower: 'デバイス算力'
});
Object.assign(aitokenPageMessages.jp.aitoken.orders, {
  title: '私の注文', refresh: '注文を更新', quickTitle: '小額購入注文', quickDesc: '未当選注文は課金されず、成功後は毎日収益を精算します。',
  deviceTitle: 'デバイス申込注文', deviceDesc: '申込成功後、毎日収益を精算します', countUnit: '件', quickPower: '小額算力',
  queuing: '購入中', running: '稼働中', finished: '終了', configuring: '設定中', closed: '未稼働', invested: '投入', cycle: '周期',
  day: '日', rate: '収益率', dailyIncome: '毎日収益', type: 'タイプ', deviceCode: '設備コード', hosting: '委託', delivery: '配送',
  ranDays: '稼働日数', earned: '獲得済み'
});
Object.assign(aitokenPageMessages.jp.aitoken.referral, {
  defaultLevel: '算力ノード', myToken: '私のToken', tokenUnit: '個', myDevice: '私のデバイス', deviceUnit: '台',
  inviteLink: '招待リンク', myReferrer: '私の紹介者', todayIncome: '本日の収益', reward: '報酬',
  quotaIncome: '枠収益', deviceIncome: 'デバイス収益', channelIncome: 'チャネル収益', myTeam: '私のチーム',
  myReferral: '私の紹介', teamDevice: 'チームデバイス', directDevice: '直接紹介デバイス', deviceCount: 'デバイス数'
});
aitokenPageMessages.ko = JSON.parse(JSON.stringify(aitokenPageMessages.en));
aitokenPageMessages.ko.aitoken.tabs = { home: '홈', business: '비즈니스', orders: '주문', referral: '추천' };
aitokenPageMessages.ko.aitoken.connectWallet = '지갑 연결';
aitokenPageMessages.ko.aitoken.connectLogin = '지갑 연결 / 로그인';
Object.assign(aitokenPageMessages.ko.aitoken.common, {
  record: '기록', confirm: '확인', submit: '제출', buyNow: '지금 구매', subscribeNow: '지금 신청',
  purchased: '구매 완료', onceOnly: '1회 한정', noQuickPlans: '구매 설정 없음', noDevicePlans: '장비 설정 없음',
  noQuickOrders: '구매 주문 없음', noDeviceOrders: '장비 주문 없음', noData: '데이터 없음',
  requestFailed: '요청 실패', operationFailed: '작업 실패', operationSuccess: '작업 성공', loginFirst: '먼저 인증 로그인하세요'
});
Object.assign(aitokenPageMessages.ko.aitoken.home, {
  title: '글로벌 AI 모델을 위한 데이터와 신뢰 레이어', intro: 'GMI Cloud Pte.Ltd AI 네이티브 추론 클라우드는 지갑 인증, 충전, 출금, 신청 흐름과 연결됩니다.',
  stat1: '참여 조건', stat2: '최대 월 수익률', stat3: '추천 보상', enterBusiness: '비즈니스로 이동',
  upgradeTitle: '1000 USDT 도시 파트너 좌석, 기간 및 수량 한정', upgradeDesc: '사용자당 1회만 구매 가능하며 구매 후 즉시 도시 파트너 좌석으로 업그레이드됩니다.',
  featureTitle: '세 가지 수익 모델', featureDesc: '해시레이트, 장비, 추천 수익이 동일한 계정 흐름으로 통합됩니다.',
  feature1Desc: 'NVIDIA 기반 Serverless 추론과 전용 GPU 인프라.', feature2Title: '소액 해시레이트 빠른 구매',
  feature2Desc: '단기 구매 입구로 기존 신청 흐름에 연결됩니다.', feature3Title: '장비 해시레이트 신청',
  feature3Desc: '장비 주문은 온체인 인증과 주문 확인 기능을 재사용합니다.', feature4Title: '추천 보상',
  feature4Desc: '추천 데이터와 커미션 출금은 기존 계정 체계를 통해 처리됩니다.', bindTitle: '상위 추천인 연결',
  bindDesc: '초대 주소 또는 초대 코드를 입력하면 비즈니스와 추천 보상에 참여할 수 있습니다.',
  bindPlaceholder: '초대 코드를 입력하세요', bindButton: '연결 확인', buyFailed: '구매 실패', bindSuccess: '연결 성공'
});
Object.assign(aitokenPageMessages.ko.aitoken.business, {
  title: 'Token 해시레이트 한도 활성화, 장비 구매, 추천 보상', desc1: '해시레이트 한도를 활성화하면 수익은 매일 정산되고 만기 시 원금이 반환됩니다.',
  desc2: '장비 해시레이트 신청, 수익은 매일 정산됩니다.', walletTitle: '지갑 자산', walletDesc: '사용 가능 잔액과 추천 커미션',
  balance: 'USDT 잔액', commission: '커미션', recharge: '지갑 충전', balanceWithdraw: '잔액 출금',
  commissionWithdraw: '커미션 출금', commissionToBalance: '커미션을 잔액으로', quickTitle: '해시레이트 한도 활성화',
  quickDesc: '각 등급은 사용자당 1회만 구매 가능', shortTerm: '단기 참여형', day: '일', tokenUnit: 'Token',
  dailyRate: '일 수익률', remaining: '잔여', quickRule: '구매 성공 후 매일 수익이 지급되고 만기 시 원금이 반환됩니다. 미당첨 시 차감되지 않습니다.',
  deviceTitle: '해시레이트 장비 배치', deviceDesc: '표준 투입은 장비당 1260 USDT입니다.', longTerm: '장기 산출형',
  recommend: '추천', cycle: '주기', longCycle: '장기', unitPrice: '단가', deviceRule: '장비 신청 수익은 매일 정산됩니다',
  chooseDeviceMethod: '장비 수령 방식 선택', onlineHost: '온라인 위탁', onlineHostDesc: '플랫폼이 장비를 통합 위탁 관리합니다',
  delivery: '자택 배송', comingSoon: '준비 중', deliveryDesc: '장비를 집으로 배송하며 수령 정보가 필요합니다',
  deliveryTitle: '수령 정보 입력', receiverName: '수령인', receiverPhone: '전화번호', receiverAddress: '주소',
  receiverNamePlaceholder: '수령인 이름 입력', receiverPhonePlaceholder: '전화번호 입력', receiverAddressPlaceholder: '상세 주소 입력',
  fillName: '수령인 이름을 입력하세요', fillPhone: '전화번호를 입력하세요', fillAddress: '주소를 입력하세요', devicePower: '장비 해시레이트'
});
Object.assign(aitokenPageMessages.ko.aitoken.orders, {
  title: '내 주문', refresh: '주문 새로고침', quickTitle: '소액 구매 주문', quickDesc: '미당첨 주문은 차감되지 않으며 성공 후 매일 수익이 정산됩니다.',
  deviceTitle: '장비 신청 주문', deviceDesc: '신청 성공 후 매일 수익이 정산됩니다', countUnit: '건', quickPower: '소액 해시레이트',
  queuing: '구매 중', running: '운영 중', finished: '종료됨', configuring: '설정 중', closed: '미운영', invested: '투입',
  cycle: '주기', day: '일', rate: '수익률', dailyIncome: '일일 수익', type: '유형', deviceCode: '장비 코드', hosting: '위탁',
  delivery: '배송', ranDays: '운영 일수', earned: '획득 수익'
});
Object.assign(aitokenPageMessages.ko.aitoken.referral, {
  defaultLevel: '해시레이트 노드', myToken: '내 Token', tokenUnit: '개', myDevice: '내 장비', deviceUnit: '대',
  inviteLink: '초대 링크', myReferrer: '내 추천인', todayIncome: '오늘 수익', reward: '보상',
  quotaIncome: '한도 수익', deviceIncome: '장비 수익', channelIncome: '채널 수익', myTeam: '내 팀',
  myReferral: '내 추천', teamDevice: '팀 장비', directDevice: '직접 추천 장비', deviceCount: '장비 수'
});
aitokenPageMessages.yn = JSON.parse(JSON.stringify(aitokenPageMessages.en));
aitokenPageMessages.yn.aitoken.tabs = { home: 'Trang chủ', business: 'Dịch vụ', orders: 'Đơn hàng', referral: 'Giới thiệu' };
aitokenPageMessages.yn.aitoken.connectWallet = 'Kết nối ví';
aitokenPageMessages.yn.aitoken.connectLogin = 'Kết nối ví / Đăng nhập';
Object.assign(aitokenPageMessages.yn.aitoken.common, {
  record: 'Lịch sử', confirm: 'Xác nhận', submit: 'Gửi', buyNow: 'Mua ngay', subscribeNow: 'Đăng ký ngay',
  purchased: 'Đã mua', onceOnly: 'Chỉ mua một lần', noQuickPlans: 'Chưa có gói mua nhanh', noDevicePlans: 'Chưa có gói thiết bị',
  noQuickOrders: 'Chưa có đơn mua nhanh', noDeviceOrders: 'Chưa có đơn thiết bị', noData: 'Không có dữ liệu',
  requestFailed: 'Yêu cầu thất bại', operationFailed: 'Thao tác thất bại', operationSuccess: 'Thao tác thành công', loginFirst: 'Vui lòng xác thực đăng nhập trước'
});
Object.assign(aitokenPageMessages.yn.aitoken.home, {
  title: 'Lớp dữ liệu và niềm tin cho các mô hình AI toàn cầu', intro: 'Đám mây suy luận AI gốc của GMI Cloud Pte.Ltd kết nối ví, nạp rút và quy trình đăng ký.',
  stat1: 'Ngưỡng tham gia', stat2: 'Lãi tháng tối đa', stat3: 'Thưởng giới thiệu', enterBusiness: 'Vào dịch vụ',
  upgradeTitle: '1000 USDT ghế đối tác thành phố, giới hạn thời gian và số lượng', upgradeDesc: 'Mỗi người chỉ mua một lần, sau khi mua sẽ nâng cấp thành đối tác thành phố.',
  featureTitle: 'Ba mô hình thu nhập', featureDesc: 'Thu nhập từ hashrate, thiết bị và giới thiệu được quản lý trong cùng hệ thống tài khoản.',
  feature1Desc: 'Hạ tầng GPU chuyên dụng và suy luận Serverless do NVIDIA hỗ trợ.', feature2Title: 'Hashrate nhỏ mua nhanh',
  feature2Desc: 'Cổng mua chu kỳ ngắn, kết nối quy trình đăng ký hiện có.', feature3Title: 'Đăng ký hashrate thiết bị',
  feature3Desc: 'Đơn thiết bị dùng chung xác thực on-chain và xác nhận đơn hàng.', feature4Title: 'Thưởng giới thiệu',
  feature4Desc: 'Dữ liệu giới thiệu và rút hoa hồng tiếp tục đi qua hệ thống tài khoản hiện có.', bindTitle: 'Liên kết cấp trên',
  bindDesc: 'Nhập địa chỉ hoặc mã mời để tham gia dịch vụ và nhận thưởng giới thiệu.',
  bindPlaceholder: 'Nhập mã mời', bindButton: 'Xác nhận liên kết', buyFailed: 'Mua thất bại', bindSuccess: 'Liên kết thành công'
});
Object.assign(aitokenPageMessages.yn.aitoken.business, {
  title: 'Kích hoạt hạn mức Token hashrate, mua thiết bị Token, thưởng giới thiệu', desc1: 'Kích hoạt hạn mức hashrate, thu nhập quyết toán hằng ngày, hoàn vốn khi đáo hạn.',
  desc2: 'Đăng ký hashrate thiết bị, thu nhập quyết toán hằng ngày.', walletTitle: 'Tài sản ví', walletDesc: 'Số dư khả dụng và hoa hồng giới thiệu',
  balance: 'Số dư USDT', commission: 'Hoa hồng', recharge: 'Nạp ví', balanceWithdraw: 'Rút số dư',
  commissionWithdraw: 'Rút hoa hồng', commissionToBalance: 'Chuyển hoa hồng sang số dư', quickTitle: 'Kích hoạt hạn mức hashrate',
  quickDesc: 'Mỗi cấp mỗi người chỉ được mua một lần', shortTerm: 'Ngắn hạn', day: 'ngày', tokenUnit: 'Token',
  dailyRate: 'Lãi ngày', remaining: 'Còn lại', quickRule: 'Sau khi mua thành công sẽ nhận thu nhập hằng ngày, hết chu kỳ hoàn vốn; không trúng sẽ không trừ tiền.',
  deviceTitle: 'Triển khai thiết bị hashrate', deviceDesc: 'Tiêu chuẩn đầu tư là 1260 USDT/máy.', longTerm: 'Dài hạn',
  recommend: 'Đề xuất', cycle: 'Chu kỳ', longCycle: 'Dài hạn', unitPrice: 'Đơn giá', deviceRule: 'Đăng ký thiết bị quyết toán thu nhập hằng ngày',
  chooseDeviceMethod: 'Chọn cách nhận thiết bị', onlineHost: 'Lưu ký trực tuyến', onlineHostDesc: 'Nền tảng quản lý thiết bị tập trung, tiện lợi',
  delivery: 'Giao tận nhà', comingSoon: 'Sắp mở', deliveryDesc: 'Thiết bị giao đến nhà, cần điền thông tin nhận hàng',
  deliveryTitle: 'Điền thông tin nhận hàng', receiverName: 'Tên người nhận', receiverPhone: 'Số điện thoại', receiverAddress: 'Địa chỉ',
  receiverNamePlaceholder: 'Nhập tên người nhận', receiverPhonePlaceholder: 'Nhập số điện thoại', receiverAddressPlaceholder: 'Nhập địa chỉ chi tiết',
  fillName: 'Vui lòng nhập tên người nhận', fillPhone: 'Vui lòng nhập số điện thoại', fillAddress: 'Vui lòng nhập địa chỉ', devicePower: 'Hashrate thiết bị'
});
Object.assign(aitokenPageMessages.yn.aitoken.orders, {
  title: 'Đơn hàng của tôi', refresh: 'Làm mới đơn hàng', quickTitle: 'Đơn mua nhanh', quickDesc: 'Đơn không trúng không bị trừ tiền, sau khi mua thành công thu nhập quyết toán hằng ngày.',
  deviceTitle: 'Đơn đăng ký thiết bị', deviceDesc: 'Sau khi đăng ký thành công, thu nhập quyết toán hằng ngày', countUnit: 'mục', quickPower: 'Hashrate nhỏ',
  queuing: 'Đang mua', running: 'Đang chạy', finished: 'Đã kết thúc', configuring: 'Đang cấu hình', closed: 'Chưa chạy', invested: 'Đầu tư',
  cycle: 'Chu kỳ', day: 'ngày', rate: 'Tỷ suất', dailyIncome: 'Thu nhập ngày', type: 'Loại', deviceCode: 'Mã thiết bị', hosting: 'Lưu ký',
  delivery: 'Giao hàng', ranDays: 'Số ngày chạy', earned: 'Đã nhận'
});
Object.assign(aitokenPageMessages.yn.aitoken.referral, {
  defaultLevel: 'Nút hashrate', myToken: 'Token của tôi', tokenUnit: '', myDevice: 'Thiết bị của tôi', deviceUnit: '',
  inviteLink: 'Liên kết mời', myReferrer: 'Người giới thiệu của tôi', todayIncome: 'Thu nhập hôm nay', reward: 'Thưởng',
  quotaIncome: 'Thu nhập hạn mức', deviceIncome: 'Thu nhập thiết bị', channelIncome: 'Thu nhập kênh', myTeam: 'Đội nhóm của tôi',
  myReferral: 'Giới thiệu của tôi', teamDevice: 'Thiết bị đội nhóm', directDevice: 'Thiết bị trực tiếp', deviceCount: 'Số thiết bị'
});

Object.assign(aitokenPageMessages.jp.aitoken.homePages, {
  usdtRecord: 'USDT記録',
  commissionRecord: 'コミッション記録',
  balanceWithdrawalRecord: '残高出金記録',
  commissionWithdrawalRecord: 'コミッション出金記録',
  time: '時間',
  amount: '数量',
  description: '説明',
  withdrawTime: '出金時間',
  money: '金額',
  received: '着金',
  fee: '手数料',
  status: '状態',
  noRecords: '記録なし',
  loading: '読み込み中...',
  noMore: 'これ以上ありません',
  pending: '処理待ち',
  paid: '着金済み',
  rejected: '拒否済み',
  unknown: '不明',
  balanceWithdrawal: '残高出金',
  commissionWithdrawal: 'コミッション出金',
  record: '記録',
  balance: '残高',
  commission: 'コミッション',
  availableBalance: '利用可能残高',
  availableCommission: '利用可能コミッション',
  withdrawAmount: '出金数量',
  withdrawPlaceholder: '出金数量を入力',
  receivedAmount: '着金数量',
  confirmWithdraw: '出金を確認',
  insufficientBalance: '残高不足',
  insufficientCommission: 'コミッション不足',
  signatureFailed: '署名失敗',
  commissionToBalance: 'コミッションを残高へ',
  exchangeRate: '1:1交換',
  transferAmount: '振替数量',
  transferPlaceholder: '振替数量を入力',
  balanceReceived: '着金残高',
  freeFee: '手数料無料',
  confirmTransfer: '残高へ振替',
  transferSuccess: '振替成功',
  transferFailed: '振替失敗',
});

Object.assign(aitokenPageMessages.ko.aitoken.homePages, {
  usdtRecord: 'USDT 기록',
  commissionRecord: '커미션 기록',
  balanceWithdrawalRecord: '잔액 출금 기록',
  commissionWithdrawalRecord: '커미션 출금 기록',
  time: '시간',
  amount: '수량',
  description: '설명',
  withdrawTime: '출금 시간',
  money: '금액',
  received: '입금액',
  fee: '수수료',
  status: '상태',
  noRecords: '기록 없음',
  loading: '로딩 중...',
  noMore: '더 이상 없음',
  pending: '처리 대기',
  paid: '입금 완료',
  rejected: '거절됨',
  unknown: '알 수 없음',
  balanceWithdrawal: '잔액 출금',
  commissionWithdrawal: '커미션 출금',
  record: '기록',
  balance: '잔액',
  commission: '커미션',
  availableBalance: '사용 가능 잔액',
  availableCommission: '사용 가능 커미션',
  withdrawAmount: '출금 수량',
  withdrawPlaceholder: '출금 수량을 입력하세요',
  receivedAmount: '입금 수량',
  confirmWithdraw: '출금 확인',
  insufficientBalance: '잔액 부족',
  insufficientCommission: '커미션 부족',
  signatureFailed: '서명 실패',
  commissionToBalance: '커미션을 잔액으로',
  exchangeRate: '1:1 교환',
  transferAmount: '전환 수량',
  transferPlaceholder: '전환 수량을 입력하세요',
  balanceReceived: '입금 잔액',
  freeFee: '수수료 없음',
  confirmTransfer: '잔액으로 전환',
  transferSuccess: '전환 성공',
  transferFailed: '전환 실패',
});

Object.assign(aitokenPageMessages.yn.aitoken.homePages, {
  usdtRecord: 'Lịch sử USDT',
  commissionRecord: 'Lịch sử hoa hồng',
  balanceWithdrawalRecord: 'Lịch sử rút số dư',
  commissionWithdrawalRecord: 'Lịch sử rút hoa hồng',
  time: 'Thời gian',
  amount: 'Số lượng',
  description: 'Mô tả',
  withdrawTime: 'Thời gian rút',
  money: 'Số tiền',
  received: 'Nhận được',
  fee: 'Phí',
  status: 'Trạng thái',
  noRecords: 'Chưa có lịch sử',
  loading: 'Đang tải...',
  noMore: 'Không còn dữ liệu',
  pending: 'Đang xử lý',
  paid: 'Đã nhận',
  rejected: 'Đã từ chối',
  unknown: 'Không rõ',
  balanceWithdrawal: 'Rút số dư',
  commissionWithdrawal: 'Rút hoa hồng',
  record: 'Lịch sử',
  balance: 'Số dư',
  commission: 'Hoa hồng',
  availableBalance: 'Số dư khả dụng',
  availableCommission: 'Hoa hồng khả dụng',
  withdrawAmount: 'Số lượng rút',
  withdrawPlaceholder: 'Nhập số lượng rút',
  receivedAmount: 'Số lượng nhận',
  confirmWithdraw: 'Xác nhận rút',
  insufficientBalance: 'Số dư không đủ',
  insufficientCommission: 'Hoa hồng không đủ',
  signatureFailed: 'Ký thất bại',
  commissionToBalance: 'Chuyển hoa hồng sang số dư',
  exchangeRate: 'Quy đổi 1:1',
  transferAmount: 'Số lượng chuyển',
  transferPlaceholder: 'Nhập số lượng chuyển',
  balanceReceived: 'Số dư nhận',
  freeFee: 'Miễn phí',
  confirmTransfer: 'Chuyển sang số dư',
  transferSuccess: 'Chuyển thành công',
  transferFailed: 'Chuyển thất bại',
});

Object.assign(aitokenPageMessages.jp.aitoken.business, {
  quickSuccess: '購入成功',
  deviceSuccess: '申込成功',
});

Object.assign(aitokenPageMessages.ko.aitoken.business, {
  quickSuccess: '구매 성공',
  deviceSuccess: '신청 성공',
});

Object.assign(aitokenPageMessages.yn.aitoken.business, {
  quickSuccess: 'Mua thành công',
  deviceSuccess: 'Đăng ký thành công',
});

Object.assign(aitokenPageMessages.cn.aitoken.referral, {
  level1: '\u7b97\u529b\u8282\u70b9',
  level2: '\u7b97\u529b\u533a/\u53bf\u7ea7\u670d\u52a1\u516c\u53f8',
  level3: '\u7b97\u529b\u5e02\u7ea7\u670d\u52a1\u516c\u53f8',
  level4: '\u7b97\u529b\u7701\u7ea7\u670d\u52a1\u516c\u53f8',
  level5: '\u8054\u5408\u521b\u59cb\u4eba',
});

Object.assign(aitokenPageMessages.en.aitoken.referral, {
  level1: 'Hashrate Node',
  level2: 'District/County Hashrate Service Company',
  level3: 'City Hashrate Service Company',
  level4: 'Provincial Hashrate Service Company',
  level5: 'Co-founder',
});

Object.assign(aitokenPageMessages.jp.aitoken.referral, {
  level1: '\u7b97\u529b\u30ce\u30fc\u30c9',
  level2: '\u533a/\u770c\u30ec\u30d9\u30eb\u7b97\u529b\u30b5\u30fc\u30d3\u30b9\u4f1a\u793e',
  level3: '\u5e02\u30ec\u30d9\u30eb\u7b97\u529b\u30b5\u30fc\u30d3\u30b9\u4f1a\u793e',
  level4: '\u7701\u30ec\u30d9\u30eb\u7b97\u529b\u30b5\u30fc\u30d3\u30b9\u4f1a\u793e',
  level5: '\u5171\u540c\u5275\u696d\u8005',
});

Object.assign(aitokenPageMessages.ko.aitoken.referral, {
  level1: '\ud574\uc2dc\ub808\uc774\ud2b8 \ub178\ub4dc',
  level2: '\uad6c/\ud604\uae09 \ud574\uc2dc\ub808\uc774\ud2b8 \uc11c\ube44\uc2a4 \ud68c\uc0ac',
  level3: '\uc2dc\uae09 \ud574\uc2dc\ub808\uc774\ud2b8 \uc11c\ube44\uc2a4 \ud68c\uc0ac',
  level4: '\uc131\uae09 \ud574\uc2dc\ub808\uc774\ud2b8 \uc11c\ube44\uc2a4 \ud68c\uc0ac',
  level5: '\uacf5\ub3d9 \ucc3d\uc5c5\uc790',
});

Object.assign(aitokenPageMessages.yn.aitoken.referral, {
  level1: 'N\u00fat hashrate',
  level2: 'C\u00f4ng ty d\u1ecbch v\u1ee5 hashrate c\u1ea5p qu\u1eadn/huy\u1ec7n',
  level3: 'C\u00f4ng ty d\u1ecbch v\u1ee5 hashrate c\u1ea5p th\u00e0nh ph\u1ed1',
  level4: 'C\u00f4ng ty d\u1ecbch v\u1ee5 hashrate c\u1ea5p t\u1ec9nh',
  level5: '\u0110\u1ed3ng s\u00e1ng l\u1eadp',
});

Object.keys(aitokenPageMessages).forEach((locale) => {
  messages[locale] = {
    ...messages[locale],
    aitoken: {
      ...(messages[locale] && messages[locale].aitoken ? messages[locale].aitoken : {}),
      ...aitokenPageMessages[locale].aitoken,
    },
  }
})

const i18n = new VueI18n({
  messages,
  locale: getSavedLocale(),
  fallbackLocale: 'cn',
  silentTranslationWarn: true,
})

export default i18n;
